// Read scheduling only: never removes resources or changes sidebar membership.
export function createChannelReadGate() {
  let accessKey, allowed = null, version = 0;
  const deniedIds = new Set(), deniedChannels = new Set();
  const reset = () => { deniedIds.clear(); deniedChannels.clear(); version++; };
  return {
    access(key) {
      if (key === accessKey) return;
      accessKey = key; allowed = null; reset();
    },
    accounts(items) {
      const next = new Set(items.map(item => item.id));
      if (allowed && (next.size !== allowed.size || [...next].some(id => !allowed.has(id)))) reset();
      allowed = next;
    },
    ticket: () => version,
    ready: () => allowed !== null,
    allows(id, channel) {
      return !deniedIds.has(id) && (!channel || ((!allowed || allowed.has(channel)) && !deniedChannels.has(channel)));
    },
    refused(id, channel, error, ticket) {
      if (ticket !== version || error?.status !== 403 || error?.code !== 'MESSAGING_FORBIDDEN') return;
      deniedIds.add(id);
      if (channel) deniedChannels.add(channel);
    },
  };
}
